import React, { PureComponent } from 'react';

import NotFoundTemplate from './NotFoundTemplate';

class NotFound extends PureComponent {
  render() {
    return (
      <NotFoundTemplate />
    );
  }
}

export default {
  path: '*',
  exact: true,
  component: NotFound
};



// WEBPACK FOOTER //
// ./src/components/NotFound/index.js